<section class="flex md:h-full flex-col items-center overflow-y-scroll overflow-x-hidden bg-pst-green-100 relative transition-all ease-linear z-50" 
    [ngClass]="{'md:w-[200px] h-full': this.isOpened, 'md:w-[80px] h-auto md:!h-full': !this.isOpened}">
    
    <header class="flex justify-center items-center h-[62px] w-full p-0" [class]="{'!justify-between': this.isMobileVersion}">
        @if (this.isOpened) {
            <button mat-button color="primary" (click)="this.toggleSidebar()" class="justify-items-center text-white !w-full !h-full">
                <img class="w-full z-[1] xs:!scale-50 md:!scale-100" [src]="'assets/logo/logo-horizontal.png'" alt="app-logo"/>
            </button>
        } @else {
            <button mat-button color="primary" (click)="this.toggleSidebar()" class="!p-0 justify-items-center text-white !w-full !h-full">
                <img class="!h-10 !w-10 z-[1]" [src]="'assets/logo/logo.png'" alt="app-logo"/>
            </button>
        }

        @if (this.isMobileVersion && this.isOpened) {
            <button id="alert" class="flex items-center justify-end rounded-md hover:bg-pst-green-15 transition-all duration-300 mr-2" (click)="this.openMenu()">
                @if (this.notificationsCount !== 0) {
                    <mat-icon class="scale-75 custom-badge" aria-hidden="false" [matBadge]="this.notificationsCount" svgIcon="notification"></mat-icon>
                } @else {
                    <mat-icon class="scale-75" svgIcon="notification"></mat-icon>
                }
            </button>
        }
    </header>

    @if (this.isOpened || !this.isMobileVersion) {
        @for (section of sections; track $index; let last = $last) {
            @for (icon of section; track $index) {
                @if(!icon.permission || (this.permissionsService?.getGrantedPolicy$(icon.permission) | async)) {
                    <section [routerLink]="!icon.openMenu ? '/' + icon.url : null" class="px-[0.75rem] py-[0.625rem] w-full cursor-pointer z-10"
                        [ngClass]="{'!py-[0.2rem] mt-[0.25rem]' : this.isOpened, 'justify-items-center' : !this.isOpened}">
                        <button [id]="icon.openMenu ? 'alert' : $index.toString()" 
                                class="flex items-center black-icons text-white justify-center rounded-md hover:bg-pst-green-15 hover:text-pst-black-75
                                    transition-all duration-300 p-[0.625rem] w-full" 
                                [ngClass]="{'w-fit bg-pst-green-15': this.checkIfUrlMatches(icon.url), 'w-full !justify-start py-[0.5rem] pl-[0.2rem]' : this.isOpened}"
                                (click)="icon.openMenu ? this.openMenu() : null"
                        >
                            @if (icon.openMenu && this.notificationsCount !== 0) {
                                <mat-icon 
                                    class="!h-6 !w-6 custom-badge hover:!text-pst-black-75" aria-hidden="false" 
                                    [matBadge]="this.notificationsCount" svgIcon="{{ icon.icon }}"
                                    [ngClass]="{'!text-pst-black-75': this.checkIfUrlMatches(icon.url)}"
                                >

                                </mat-icon>
                            } @else {
                                <mat-icon class="!h-6 !w-6 hover:!text-pst-black-75" svgIcon="{{ icon.icon }}"  
                                    [ngClass]="{'!text-pst-black-75': this.checkIfUrlMatches(icon.url)}"
                                >
                                </mat-icon>
                            }
                            @if (this.isOpened) {
                                <a 
                                    @appear class="ml-2 text-start hover:!text-pst-black-75"
                                    [ngClass]="{'!text-pst-black-75': this.checkIfUrlMatches(icon.url)}"
                                    >
                                        {{ icon.title }}
                                </a>
                            }
                        </button>
                    </section>
                    
                    @if (this.isOpened) {
                        @for (item of icon.children; track $index) {
                            <section 
                                [routerLink]="'/'+ item.url" class="pl-[32px] pr-2 py-[0.75rem] text-pst-green-10 w-full cursor-pointer" 
                                [ngClass]="{'!py-[0.2rem]' : this.isOpened}"
                            >
                                <button class="w-full flex items-center black-icons justify-center rounded-md hover:bg-pst-green-15 transition-all duration-300" 
                                    [ngClass]="{'bg-pst-green-15 !text-pst-black-75': this.checkIfUrlMatches(item.url), '!justify-start py-[0.5rem] pl-[0.2rem]' : this.isOpened}">
                                    <mat-icon 
                                        [ngClass]="{'!text-pst-black-75': this.checkIfUrlMatches(item.url)}"
                                        class="scale-75 text-white" svgIcon="{{ item.icon }}"></mat-icon>
                                    @if (this.isOpened) {
                                        <a @appear class="ml-2 !text-start text-white" 
                                            [ngClass]="{'!text-pst-black-75': this.checkIfUrlMatches(item.url)}"
                                        >
                                            {{ item.title }}
                                        </a>
                                    }
                                </button>
                            </section>
                        }
                    }
                }
            }
            
            @if (!last) {
                <div [ngClass]="{'w-1/2': !this.isOpened, 'w-full': this.isOpened}">
                    <mat-divider class="!border-t-pst-green-15"></mat-divider>
                </div>
            }
        }

        <span class="flex-1"></span>

        @for (icon of footerSectionIcons; track $index) {
            <section class="w-full flex justify-center items-center px-[0.75rem] py-[0.625rem]">
                <button 
                    [routerLink]="'/' + icon.url" 
                    class="p-[0.625rem] cursor-pointer flex items-center text-white rounded-md hover:bg-pst-green-15 transition-all duration-300 black-icons" 
                    [ngClass]="{'mr-2 border-solid' : this.isOpened}" (click)="this.closeSession()"
                >
                    <mat-icon class="scale-75 text-white" svgIcon="{{ icon.icon }}"></mat-icon>
                    @if (this.isOpened) {
                        <a @appear class="text-white ml-2 hover:!text-pst-black-75" >{{ icon.title }}</a>
                    }
                </button>
            </section>
        }
    }

    <app-notifications (seenNotifications)="decreaseSeenNotifications($event)" [isMobileVersion]="this.isMobileVersion"></app-notifications>
</section>